import store from '../../../../admin/store'

export const fetchEvents = (reset = false, limit = 30, defaultTypes = false) => {
    const appState = store.getState().app

    const events = appState.events
    const busy = store.getState().ui.busySections.events
    const cursor = reset ? 0 : events.cursor

    if (cursor === null || busy) {
        return Promise.resolve()
    }

    const defaultTag = events.defaultTag ? events.defaultTag.defaultTag : null
    const filters = events.filters && events.filters.filters ? `&${events.filters.filters}` : ''

    store.dispatch({
        type: 'TOGGLE_BUSY_SECTION',
        section: 'events',
    })

    const defaultCity = window.APP_CONFIG.REACT_APP_DEFAULT_CITY_FILTER_NAME

    const includes = [
        'locations',
        'sports',
        'additionalInfo',
    ].join(',')

    let defaultFilters = [
        `cursor=${cursor}`,
        `limit=${limit}`,
        'publishable=true',
        `tz=${moment.tz.guess()}`,
        `city=${defaultCity}`,
        `${(filters !== '' || !defaultTypes ? '' : 'types=1,5,6')}`,
        `${(filters !== '' ? '' : 'dateType=next')}`,
        `system=${window.APP_CONFIG.REACT_APP_SYSTEM}`,
    ].filter(filt => filt && filt !== '')

    if (defaultTag) {
        defaultFilters.push(`tags=${defaultTag}`)
    }

    return window.axios.get(
        `${window.APP_CONFIG.REACT_APP_API_URL}api/events?include=${includes}${filters}&${defaultFilters.join('&')}`
    ).then(({ data }) => {
        store.dispatch({
            type: 'TOGGLE_BUSY_SECTION',
            section: 'events',
        })

        return store.dispatch({
            type: 'EVENTS_FETCHED',
            events: data.data,
            meta: data.meta,
            reset,
        })
    })
}
